// Importaciones necesarias al inicio del archivo
import { useDonation } from '../context/DonationContext';
import { Outlet } from 'react-router-dom';
// import { useNavigate, Outlet } from 'react-router-dom';
import ProgressSteps from '../components/layout/ProgressSteps';

export default function DonationFlow() {
    const { donation, updateDonation } = useDonation();
    // const navigate = useNavigate();

    const steps = [
        { path: 'informacion', name: 'Tus datos' },
        { path: 'pago', name: 'Método de pago' },
        { path: 'confirmacion', name: 'Confirmación' }
    ];

    return (
        <div className="max-w-2xl mx-auto p-4">
            <ProgressSteps steps={steps} />
            <Outlet context={{ donation, updateDonation }} />
        </div>
    );
}